import { render, staticRenderFns } from "./wanneer-dakkapel-plaatsen.vue?vue&type=template&id=b95116ae"
import script from "./wanneer-dakkapel-plaatsen.vue?vue&type=script&lang=js"
export * from "./wanneer-dakkapel-plaatsen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports